import { combineReducers } from "redux";
import settings from "./settings/reducer";
import menu from "./menu/reducer";
import authUser from "./auth/reducer";
import todoApp from "./todo/reducer";
import chatApp from "./chat/reducer";
import surveyListApp from "./surveyList/reducer";
import surveyDetailApp from "./surveyDetail/reducer";
import UserSlice from "./user/UserSlice";
import CenterDataSlice from "./user/CenterDataSlice";
import CompanySlice from "./user/CompanySlice";
import AssetSlice from "./user/AssetSlice";
import AuthenSlice from "./user/AuthenSlice";
import UploadAssetSlice from "./user/UploadAssetSlice";
import BookingSlice from "./user/BookingSlice";
import UtilitySlice from "./user/UtilitySlice";
import BillSlice from "./user/BillSlice";
import ReportSlice from "./user/ReportSlice";
import firebaseSlice from "./user/firebaseSlice";

const rootReducers = combineReducers({
  menu,
  settings,
  authUser,
  todoApp,
  chatApp,
  surveyListApp,
  surveyDetailApp,
  UserSlice,
  CenterDataSlice,
  CompanySlice,
  // OrganizationSlice,
  AssetSlice,
  AuthenSlice,
  UploadAssetSlice,
  BookingSlice,
  UtilitySlice,
  // OriginCoreSlice,
  BillSlice,
  ReportSlice,
  firebaseSlice,
});

const reducers = (state, action) => {
  if (action.type === "RESET_ALL") {
    state = undefined;
  }
  return rootReducers(state, action);
};

export default reducers;

// export default reducers;
